<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
        >
          <title-text />
        </b-col>

        <b-col
          cols="12"
          md="6"
        >
          <year />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <ordering />
        </b-col>

        <b-col
          cols="12"
        />
        <b-col cols="12">
          <content-text />
        </b-col>
      </b-row>
    </b-card>
    <image-card />
    <b-button
      variant="primary"
      :disabled="itemData.submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </div>
</template>

<script>
import {
  BCard, BCol, BRow, BButton,
} from 'bootstrap-vue'

import TitleText from '@/views/Admin/History/elements/Title.vue'
import Year from '@/views/Admin/History/elements/Year.vue'
import ImageCard from '@/views/Admin/History/elements/Image.vue'
import Ordering from '@/views/Admin/History/elements/Ordering.vue'
import ContentText from '@/views/Admin/History/elements/Content.vue'

export default {
  name: 'ItemForm',
  components: {

    BCard,
    BRow,
    BCol,
    BButton,

    TitleText,
    Year,
    ImageCard,
    Ordering,
    ContentText,
  },
  props: {
    submitForm: {
      type: Function,
      required: true,
    },
  },
  computed: {
    itemData() {
      return this.$store.getters['history/dataItem']
    },
  },
}
</script>
